import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

let state = {
  count: 1
}

let mutations = {
  updateCount() {
    state.count ++
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions: {},
  modules: {}
});
